export const locale = {
    lang: 'cs',
    data: {
        NAV: {
            DASHBOARD: 'Nástěnka',
            CLIENTS: 'Klienti',
            CONTRACTS: {
                CONTRACTS: 'Smlouvy',
                LIST: 'Seznam',
                NEW: 'Vytvořit',
            },
            ADVISORS: {
                ADVISORS: 'Poradci',
                LIST: 'Seznam',
                TREE: 'Strom',
                MANUFACTORY: 'Manufaktura',
                COMMISSION: 'Provize',
                NEW: 'Vytvořit',
            },
            REPORTS: {
                TITLE: 'Reporty',
                ADVISORS: 'Poradenské',
                HQ: 'Centrála',
            },
            APPLICANTS: {
                LIST: 'Seznam uchazečů',
            }
        }
    }
};
